export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: number;
  imageSeq: string;
  imageQuery: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'anwang91-latest-access-address',
    title: '暗网91最新入口地址获取方法（2026年8月更新）',
    excerpt: '本文详细介绍暗网91官方入口的最新获取方式，包括Tor网络配置、镜像站点验证及安全访问链路搭建，确保用户能够安全、稳定地访问暗网91平台。',
    content: `<h2>暗网91入口概述</h2><p>暗网91作为深网中备受关注的信息资源平台，其入口地址会定期更新以确保服务稳定性。了解如何安全获取最新入口地址，是每位用户必须掌握的基本技能。</p><h2>什么是Tor网络</h2><p>Tor（The Onion Router）是访问暗网的基础设施。它通过多层加密和随机路由节点，将用户的网络流量进行匿名化处理。Tor网络中的.onion域名是暗网服务的主要标识方式。</p><h2>获取暗网91入口的三种方式</h2><h3>1. 官方公告渠道</h3><p>暗网91会通过其官方公告板定期发布最新的.onion地址和镜像站点列表。建议用户收藏多个备用镜像，以应对主站不可用的情况。</p><h3>2. 社区验证站点</h3><p>多个暗网导航社区会验证并列出暗网91的有效入口。选择信誉良好的导航站进行查询，注意核对站点的数字签名。</p><h3>3. PGP签名验证</h3><p>暗网91官方会使用PGP密钥对发布的地址进行签名。用户下载地址后，务必使用官方公钥验证签名，确保地址未被篡改。</p><h2>安全访问链路搭建</h2><p>在获取地址后，建议配置Tor浏览器的安全级别为"最安全"，禁用JavaScript和非必要插件。同时使用VPN作为前置代理，形成VPN+Tor的双层匿名链路。</p><h2>常见问题</h2><p><strong>Q：为什么暗网91入口经常变动？</strong></p><p>A：暗网服务面临DDoS攻击、域名劫持等威胁，定期更换地址是维护服务可用性的必要手段。</p><p><strong>Q：如何确认访问的是真实暗网91？</strong></p><p>A：核对网站的数字证书指纹和PGP签名，与官方发布的指纹进行比对。</p>`,
    category: 'access-tutorial',
    author: '暗网91安全团队',
    publishDate: '2026-08-05',
    readTime: 8,
    imageSeq: 'article-1',
    imageQuery: 'A%20dark%20digital%20tunnel%20with%20glowing%20onion%20layers%20representing%20Tor%20network%20encryption%2C%20abstract%20cybersecurity%20concept%2C%20warm%20amber%20and%20dark%20tones%2C%20minimalist%20digital%20art%20style',
    tags: ['暗网91入口', 'Tor网络', 'onion地址', '镜像站点'],
  },
  {
    id: '2',
    slug: 'tor-browser-install-guide',
    title: 'Tor浏览器安装与配置完整教程（Windows/Mac/Linux）',
    excerpt: '从零开始教你安装配置Tor浏览器，涵盖Windows、Mac和Linux三大平台，包括安全级别设置、插件管理和匿名性优化技巧。',
    content: `<h2>Tor浏览器简介</h2><p>Tor浏览器是基于Firefox ESR开发的匿名浏览器，内置Tor网络连接功能，是访问暗网和.onion网站的标准工具。</p><h2>Windows平台安装指南</h2><p>1. 访问Tor Project官方网站（torproject.org）下载Windows版本安装包。2. 运行安装程序，选择安装语言和目录。3. 安装完成后启动Tor浏览器，点击"连接"按钮。4. 等待Tor网络连接建立，看到浏览器首页即表示连接成功。</p><h2>Mac平台安装指南</h2><p>1. 从torproject.org下载macOS版本的.dmg文件。2. 打开.dmg文件，将Tor Browser拖入应用程序文件夹。3. 首次启动时，系统可能提示"来自身份不明开发者"，前往系统偏好设置允许运行。4. 点击"连接"建立Tor网络连接。</p><h2>Linux平台安装指南</h2><p>Linux用户可以通过官方仓库或Flatpak安装Tor浏览器。推荐使用Flatpak方式：运行 flatpak install flathub com.github.micahflee.torbrowser-launcher 命令进行安装。</p><h2>安全级别设置</h2><p>Tor浏览器提供三个安全级别：标准、较安全、最安全。访问暗网时强烈建议设置为"最安全"级别，这将禁用JavaScript和部分字体渲染，最大程度降低指纹识别风险。</p><h2>隐私优化建议</h2><p>不要安装任何浏览器扩展，不要最大化浏览器窗口（避免屏幕分辨率指纹），不要用Tor浏览器登录个人账号，使用完毕后清除所有浏览数据。</p>`,
    category: 'access-tutorial',
    author: '暗网91安全团队',
    publishDate: '2026-08-03',
    readTime: 10,
    imageSeq: 'article-2',
    imageQuery: 'A%20clean%20minimalist%20digital%20workspace%20showing%20Tor%20browser%20interface%20concept%2C%20soft%20green%20and%20warm%20lighting%2C%20modern%20tech%20aesthetic%2C%20abstract%20privacy%20protection%20theme',
    tags: ['Tor浏览器', '安装教程', '安全配置', '匿名浏览'],
  },
  {
    id: '3',
    slug: 'anwang91-registration-guide',
    title: '暗网91注册与使用全流程详解',
    excerpt: '从账号注册到功能使用，完整解析暗网91平台的操作流程，包括身份验证、安全设置和平台特色功能介绍。',
    content: `<h2>注册前准备</h2><p>在注册暗网91之前，请确保已经完成Tor浏览器的安装和基本配置。建议使用全新的、与个人身份无关的邮箱地址进行注册。</p><h2>注册流程</h2><p>1. 通过已验证的暗网91入口访问注册页面。2. 填写用户名（建议使用与个人身份无关的别名）。3. 设置强密码（至少16位，包含大小写字母、数字和特殊字符）。4. 完成验证码验证。5. 记录系统生成的恢复码，妥善保管。</p><h2>安全设置</h2><p>注册完成后，立即启用双因素认证（2FA），推荐使用硬件安全密钥或时间型OTP。设置PGP密钥对，用于后续的加密通信和身份验证。</p><h2>平台功能概览</h2><p>暗网91提供信息发布、资源分享、社区讨论等核心功能。用户可根据自身需求选择相应的功能模块。建议新用户先熟悉平台规则和社区文化，再进行深度使用。</p><h2>账户安全最佳实践</h2><p>定期更换密码，不要在不同平台使用相同密码，开启登录通知功能，定期检查账户活动记录，发现异常立即冻结账户。</p>`,
    category: 'access-tutorial',
    author: '暗网91安全团队',
    publishDate: '2026-08-01',
    readTime: 7,
    imageSeq: 'article-3',
    imageQuery: 'An%20abstract%20digital%20registration%20interface%20with%20lock%20icons%20and%20shield%20symbols%2C%20warm%20amber%20accents%20on%20dark%20background%2C%20cybersecurity%20aesthetic%2C%20clean%20modern%20design',
    tags: ['暗网91注册', '账户安全', '双因素认证', 'PGP密钥'],
  },
  {
    id: '4',
    slug: 'darknet-trading-security',
    title: '暗网交易安全防护全攻略：从入门到精通',
    excerpt: '深入分析暗网交易中的安全风险，提供完整的防护策略，包括加密货币使用技巧、托管服务选择和纠纷处理方案。',
    content: `<h2>暗网交易风险概述</h2><p>暗网交易环境复杂，存在诈骗、商品质量不符、资金被盗等多种风险。了解风险类型并建立完整的防护体系是安全交易的基础。</p><h2>加密货币使用技巧</h2><p>使用门罗币（Monero）等隐私币进行交易，避免使用可追踪的比特币。建议使用混币服务增强交易匿名性。每次交易使用新生成的钱包地址，不重复使用。</p><h2>托管服务选择</h2><p>优先选择支持第三方托管服务的交易平台。了解托管服务的运作机制：买家付款后资金由托管方持有，确认收货后释放给卖家。避免直接转账交易。</p><h2>交易前验证</h2><p>仔细查看卖家的信誉评分、交易历史和用户评价。使用平台提供的争议解决机制。对于大额交易，建议先进行小额试单。</p><h2>纠纷处理方案</h2><p>保留所有交易记录和通信证据。遇到纠纷时，首先通过平台内部渠道协商解决。如无法达成一致，可申请平台仲裁。</p>`,
    category: 'security-guide',
    author: '暗网91安全团队',
    publishDate: '2026-07-28',
    readTime: 9,
    imageSeq: 'article-4',
    imageQuery: 'Abstract%20digital%20transaction%20security%20concept%20with%20shield%20and%20crypto%20symbols%2C%20warm%20green%20and%20amber%20tones%2C%20modern%20minimalist%20financial%20security%20design',
    tags: ['暗网交易', '加密货币', '门罗币', '托管服务'],
  },
  {
    id: '5',
    slug: 'identify-darknet-scams',
    title: '如何识别暗网诈骗与钓鱼网站：7大警示信号',
    excerpt: '总结暗网环境中常见的诈骗手法和钓鱼攻击方式，提供实用的识别技巧和防范措施，保护用户免受欺骗。',
    content: `<h2>暗网诈骗现状</h2><p>暗网中诈骗活动猖獗，据安全研究机构统计，约30%的暗网交易涉及欺诈行为。掌握识别技巧是保护自身安全的第一道防线。</p><h2>七大警示信号</h2><h3>1. 价格异常低廉</h3><p>远低于市场价的商品通常是诱饵，目的吸引买家上钩。对比多个平台的价格作为参考基准。</p><h3>2. 新注册账号</h3><p>注册时间短、交易记录少的卖家风险较高。优先选择有长期良好交易历史的卖家。</p><h3>3. 要求直接转账</h3><p>拒绝使用平台托管服务，要求买家直接转账是高危信号。坚持使用托管服务保障资金安全。</p><h3>4. 紧迫感话术</h3><p>卖家制造"限时优惠""库存紧张"等虚假紧迫感，促使用户匆忙决策。</p><h3>5. 沟通渠道异常</h3><p>要求在平台外沟通或使用非加密通信工具，可能是为了规避平台监管。</p><h3>6. 虚假评价</h3><p>注意识别刷单评价：评价时间集中、内容模板化、评价者账号关联性强。</p><h3>7. URL域名异常</h3><p>钓鱼网站使用与原站相似的域名，仔细核对完整URL和SSL证书信息。</p><h2>防范措施</h2><p>使用书签保存已验证的正规入口，不要点击不明链接，定期检查账户安全状态。</p>`,
    category: 'security-guide',
    author: '暗网91安全团队',
    publishDate: '2026-07-25',
    readTime: 8,
    imageSeq: 'article-5',
    imageQuery: 'A%20warning%20sign%20concept%20with%20digital%20phishing%20hook%20and%20shield%2C%20warm%20red%20and%20amber%20accents%2C%20cybersecurity%20awareness%20design%2C%20clean%20minimalist%20style',
    tags: ['暗网诈骗', '钓鱼网站', '安全识别', '交易风险'],
  },
  {
    id: '6',
    slug: 'darknet-malware-defense',
    title: '暗网恶意软件防范指南：保护你的设备与数据',
    excerpt: '系统性地介绍暗网环境中常见的恶意软件类型、感染途径和防御策略，帮助用户构建全方位的设备安全防护体系。',
    content: `<h2>暗网恶意软件威胁</h2><p>暗网中传播的恶意软件种类繁多，包括勒索软件、键盘记录器、远程访问木马（RAT）和信息窃取程序。了解这些威胁是有效防御的前提。</p><h2>常见恶意软件类型</h2><p><strong>勒索软件：</strong>加密用户文件并索要赎金。<strong>键盘记录器：</strong>记录用户所有按键输入。<strong>RAT：</strong>允许攻击者远程控制受感染设备。<strong>信息窃取程序：</strong>窃取密码、Cookie和钱包文件。</p><h2>感染途径分析</h2><p>主要感染途径包括：下载来路不明的文件、打开可疑PDF或Office文档、运行未经验证的脚本、使用盗版软件、点击短链接跳转等。</p><h2>防御策略</h2><p>1. 使用虚拟机或隔离环境访问暗网。2. 保持操作系统和安全软件更新。3. 不下载和执行任何未知来源的文件。4. 在Tor浏览器中禁用JavaScript。5. 使用专门的USB设备或Live OS进行暗网访问。</p><h2>应急响应</h2><p>怀疑设备被感染时，立即断开网络连接，备份重要数据（仅限未感染文件），使用专业工具进行全面扫描，必要时重装系统。</p>`,
    category: 'security-guide',
    author: '暗网91安全团队',
    publishDate: '2026-07-22',
    readTime: 9,
    imageSeq: 'article-6',
    imageQuery: 'Digital%20virus%20defense%20concept%20with%20shield%20blocking%20malicious%20code%2C%20warm%20green%20glow%2C%20cybersecurity%20protection%20aesthetic%2C%20modern%20minimalist%20tech%20design',
    tags: ['恶意软件', '勒索软件', '设备安全', '病毒防护'],
  },
  {
    id: '7',
    slug: 'anonymous-communication-best-practices',
    title: '暗网匿名通信最佳实践：从加密到隐藏身份',
    excerpt: '全面介绍暗网环境中的匿名通信技术，包括端到端加密、元数据保护、通信渠道选择和身份隔离策略。',
    content: `<h2>匿名通信的重要性</h2><p>在暗网环境中，每一次通信都可能暴露用户的身份信息。建立完善的匿名通信体系，是保护个人隐私和安全的基础要求。</p><h2>端到端加密技术</h2><p>使用PGP/GPG进行邮件加密，确保只有预期的接收者能够解密信息。Signal协议是目前最先进的端到端加密方案之一。理解加密原理有助于正确使用加密工具。</p><h2>元数据保护</h2><p>即使通信内容加密，通信的元数据（时间、频率、参与方）仍可能泄露信息。使用Tor网络隐藏通信的元数据，避免形成可被分析的通信模式。</p><h2>身份隔离策略</h2><p>为暗网活动创建完全独立的数字身份，不与现实身份产生任何关联。使用匿名操作系统（如Tails），所有操作在隔离环境中进行。</p><h2>通信渠道选择</h2><p>根据通信的安全需求选择合适的渠道：高安全需求使用PGP加密邮件+Tor；日常通信使用支持前向安全的端到端加密工具；避免使用任何涉及手机号验证的通信平台。</p>`,
    category: 'privacy-protection',
    author: '暗网91安全团队',
    publishDate: '2026-07-20',
    readTime: 10,
    imageSeq: 'article-7',
    imageQuery: 'Abstract%20anonymous%20communication%20concept%20with%20encrypted%20data%20streams%20flowing%20through%20layered%20nodes%2C%20warm%20amber%20and%20green%20tones%2C%20modern%20privacy%20design',
    tags: ['匿名通信', '端到端加密', 'PGP', '身份隔离'],
  },
  {
    id: '8',
    slug: 'data-encryption-techniques',
    title: '个人数据加密技术详解：AES、RSA与混合加密',
    excerpt: '深入解析主流加密算法的工作原理和应用场景，提供实用的数据加密操作指南，帮助用户保护敏感信息。',
    content: `<h2>加密技术基础</h2><p>加密是保护数据机密性的核心技术。了解对称加密和非对称加密的区别，以及各自适用的场景，是有效使用加密工具的基础。</p><h2>AES对称加密</h2><p>AES（高级加密标准）是目前最广泛使用的对称加密算法。使用256位密钥的AES-256被认为是安全的。适用于大量数据的加密，如文件加密和全盘加密。推荐使用VeraCrypt进行文件/分区加密。</p><h2>RSA非对称加密</h2><p>RSA使用公钥加密、私钥解密的机制，适合进行密钥交换和数字签名。2048位及以上的RSA密钥目前被认为是安全的。PGP/GPG就是基于RSA的加密方案。</p><h2>混合加密方案</h2><p>实际应用中通常使用混合加密：用RSA加密传输AES会话密钥，然后用AES加密实际数据。这样既利用了RSA的密钥管理优势，又发挥了AES的加密效率。</p><h2>实用工具推荐</h2><p>文件加密：VeraCrypt；邮件加密：GPG Suite / Kleopatra；即时通信：Signal；密码管理：KeePassXC。</p>`,
    category: 'privacy-protection',
    author: '暗网91安全团队',
    publishDate: '2026-07-18',
    readTime: 11,
    imageSeq: 'article-8',
    imageQuery: 'Digital%20encryption%20visualization%20with%20data%20transforming%20into%20encrypted%20blocks%2C%20warm%20green%20and%20dark%20tones%2C%20modern%20cryptography%20aesthetic%2C%20minimalist%20tech%20design',
    tags: ['数据加密', 'AES', 'RSA', 'VeraCrypt'],
  },
  {
    id: '9',
    slug: 'anwang91-platform-review',
    title: '暗网91平台真实评测报告：功能、体验与安全性分析',
    excerpt: '基于实际使用体验的暗网91平台深度评测，涵盖功能完整性、用户界面、社区质量、安全机制和可靠性等多个维度。',
    content: `<h2>评测概述</h2><p>本评测基于对暗网91平台为期三个月的实际使用，从功能、体验、安全、社区和可靠性五个维度进行客观评估。</p><h2>功能完整性（评分：8.5/10）</h2><p>暗网91提供了信息发布、资源分享、社区论坛和即时通信等核心功能。平台界面设计简洁实用，分类体系清晰。不足之处在于搜索功能有待优化，高级筛选选项较少。</p><h2>用户体验（评分：8/10）</h2><p>平台加载速度在Tor网络环境下表现稳定，页面布局合理。注册流程简洁，新手引导完善。但在高峰期偶有响应延迟。</p><h2>安全机制（评分：9/10）</h2><p>支持PGP加密通信、双因素认证、登录异常检测等安全功能。平台默认强制HTTPS/TLS加密连接。建议增加硬件安全密钥支持。</p><h2>社区质量（评分：8/10）</h2><p>社区用户活跃度较高，信息质量整体良好。平台有完善的举报和审核机制。建议加强新用户的信誉体系建设。</p><h2>可靠性（评分：8.5/10）</h2><p>平台提供多个镜像节点，服务可用性保持在95%以上。DDoS防护能力较强，宕机恢复时间短。</p>`,
    category: 'in-depth-review',
    author: '暗网91安全团队',
    publishDate: '2026-07-15',
    readTime: 8,
    imageSeq: 'article-9',
    imageQuery: 'A%20professional%20platform%20review%20dashboard%20concept%20with%20star%20ratings%20and%20analytics%2C%20warm%20amber%20accents%2C%20modern%20business%20review%20aesthetic%2C%20clean%20design',
    tags: ['暗网91评测', '平台分析', '安全性评测', '用户体验'],
  },
  {
    id: '10',
    slug: 'darknet-market-comparison',
    title: '2026年暗网市场对比分析：暗网91与其他平台',
    excerpt: '横向对比暗网91与其他主流暗网平台的功能差异、安全特性和社区生态，为用户选择提供参考依据。',
    content: `<h2>对比分析框架</h2><p>本文从平台安全性、功能丰富度、社区活跃度、交易保障机制和用户体验五个维度，对暗网91与同类平台进行横向对比。</p><h2>安全性对比</h2><p>暗网91在安全机制方面表现突出，PGP加密通信和双因素认证为标配功能。相较于部分平台仅提供基础密码保护，暗网91的安全层级更为完善。</p><h2>功能丰富度</h2><p>暗网91提供的信息分类和信息发布功能较为全面，但在自动化交易和智能合约方面仍有提升空间。部分竞品平台在去中心化交易方面具有优势。</p><h2>社区生态</h2><p>暗网91的中文社区活跃度在同类平台中名列前茅，中文内容的丰富度和质量均处于领先水平。国际化程度方面略显不足。</p><h2>综合推荐</h2><p>对于中文用户而言，暗网91是综合体验较优的选择。其强大的安全机制和活跃的中文社区是核心竞争力。建议新用户从暗网91开始体验。</p>`,
    category: 'in-depth-review',
    author: '暗网91安全团队',
    publishDate: '2026-07-12',
    readTime: 9,
    imageSeq: 'article-10',
    imageQuery: 'A%20comparison%20chart%20concept%20showing%20multiple%20platforms%20side%20by%20side%2C%20warm%20amber%20and%20green%20highlights%2C%20modern%20analytics%20design%2C%20minimalist%20data%20comparison%20aesthetic',
    tags: ['暗网市场', '平台对比', '暗网91', '横向评测'],
  },
  {
    id: '11',
    slug: 'darknet-security-trends-2026',
    title: '2026年暗网安全威胁趋势报告：最新攻击手法与防御策略',
    excerpt: '基于全球安全研究数据，分析2026年暗网安全威胁的最新趋势，包括AI驱动攻击、量子计算威胁和新型社交工程手法。',
    content: `<h2>2026年威胁概览</h2><p>2026年上半年，暗网安全威胁呈现新的变化趋势。AI技术的普及带来了更复杂的攻击手段，同时量子计算的进展对传统加密体系构成了潜在威胁。</p><h2>AI驱动攻击</h2><p>攻击者开始利用大型语言模型（LLM）生成高度定制化的钓鱼内容，传统的关键词检测方法已难以识别。AI生成的虚假身份和深度伪造内容增加了身份验证的难度。</p><h2>量子计算威胁</h2><p>虽然实用化的量子计算机尚未出现，但其对RSA和ECC加密算法的理论威胁已被广泛关注。NIST已发布后量子密码学标准，用户应关注迁移计划。</p><h2>社交工程新手法</h2><p>攻击者利用社交媒体数据构建详细的受害者画像，进行高度针对性的社交工程攻击。信任建立周期缩短，攻击成功率提升。</p><h2>防御建议</h2><p>采用零信任安全架构，对所有访问请求进行验证。关注后量子密码学的迁移进展。加强安全意识培训，提高对AI生成内容的辨别能力。</p>`,
    category: 'latest-news',
    author: '暗网91安全团队',
    publishDate: '2026-08-04',
    readTime: 7,
    imageSeq: 'article-11',
    imageQuery: 'Futuristic%20cybersecurity%20threat%20landscape%20with%20AI%20nodes%20and%20quantum%20patterns%2C%20warm%20amber%20warning%20accents%2C%20modern%20data%20visualization%20design',
    tags: ['安全趋势', 'AI攻击', '量子计算', '威胁报告'],
  },
  {
    id: '12',
    slug: 'global-darknet-regulation-updates',
    title: '全球暗网监管政策最新动态（2026年第二季度）',
    excerpt: '汇总2026年第二季度全球主要国家和地区的暗网监管政策变化，分析对用户的影响及合规使用建议。',
    content: `<h2>全球监管趋势</h2><p>2026年第二季度，多个国家和地区更新了与暗网相关的法律法规。总体趋势是加强监管力度，同时探索技术中立的立法路径。</p><h2>亚太地区</h2><p>多个亚太国家加强了对暗网相关活动的监测和执法力度。日本修订了《网络安全基本法》，扩大了监管范围。新加坡推出了新的网络安全认证框架。</p><h2>欧洲地区</h2><p>欧盟的《数字服务法》（DSA）全面实施，对暗网服务平台提出了更高的内容审核和透明度要求。GDPR执法力度持续加强。</p><h2>北美地区</h2><p>美国司法部加大了暗网犯罪的打击力度，多起重大执法行动取得成果。加拿大更新了网络安全战略，增加了对暗网活动的监控。</p><h2>合规使用建议</h2><p>了解所在地法律法规，仅将暗网用于合法目的（如隐私研究、网络安全学习）。避免参与任何可能违法的活动。关注政策变化，及时调整使用行为。</p>`,
    category: 'latest-news',
    author: '暗网91安全团队',
    publishDate: '2026-07-30',
    readTime: 8,
    imageSeq: 'article-12',
    imageQuery: 'Global%20regulation%20concept%20with%20world%20map%20and%20legal%20documents%2C%20warm%20green%20and%20amber%20tones%2C%20modern%20policy%20analysis%20design',
    tags: ['监管政策', '全球法规', '合规使用', '网络安全法'],
  },
];

export const articlesByCategory: Record<string, Article[]> = {};
articles.forEach((article) => {
  if (!articlesByCategory[article.category]) {
    articlesByCategory[article.category] = [];
  }
  articlesByCategory[article.category].push(article);
});

export const articleMap: Record<string, Article> = {};
articles.forEach((article) => {
  articleMap[article.slug] = article;
});